import React from 'react';
import PropTypes from 'prop-types';
import {
  Chip,
  Tooltip,
  Icon,
  withStyles,
  InputBase,
  Avatar,
} from '@material-ui/core';
import { debounce } from 'lodash';
import styles from './styles';

export const DEBOUNCE_TIME = 1000;

export const getColorForTagType = (tagTypes, tagTypeId) => {
  const tagType = tagTypes.filter((i) => i.id === tagTypeId)[0];
  return tagType === undefined
    ? ''
    : tagType.iconColor;
};

export const getIconForTagType = (tagTypes, tagTypeId) => {
  const tagType = tagTypes.filter((i) => i.id === tagTypeId)[0];
  return tagType === undefined
    ? ''
    : tagType.icon;
};

const isNameValid = (name) => (
  name !== null
  && name !== undefined
  && name.length >= 2
  && name.length <= 50
);

export class TagEditorComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: this.props.tag.name,
      nameValidation: true,
    };
  }

  componentDidMount() {
    this.debouncedSaveName = debounce(this.saveName, DEBOUNCE_TIME);
  }

  saveName = () => {
    this.setState((prevState) => {
      const isValid = isNameValid(prevState.name);
      if (isValid) {
        this.props.onEditTag(this.props.tag.id, { name: prevState.name });
      }
      return { nameValidation: isValid };
    });
  }

  handleNameChange = (e) => {
    this.setState({ name: e.target.value }, () => {
      this.debouncedSaveName();
    });
  }

  render() {
    return (
      <Chip
        clickable
        avatar={(
          <Avatar className={this.props.classes.avatar}>
            <Icon
              className={this.props.classes.smallIcon}
              style={{
                color: getColorForTagType(
                  this.props.tagTypes,
                  this.props.tag.tagType.id,
                ),
              }}
            >
              {getIconForTagType(this.props.tagTypes, this.props.tag.tagType.id)}
            </Icon>
          </Avatar>
        )}
        key={this.props.tag.id}
        className={this.props.classes.chip}
        label={(
          <Tooltip
            title={
              !this.state.nameValidation
                ? 'Invalid Name - Provide 2 - 50 Characters'
                : 'Type to Edit'
            }
          >
            <InputBase
              fullWidth
              inputProps={{ 'aria-label': 'naked' }}
              error={!this.state.nameValidation}
              id={'tag-name-'.concat(this.props.tag.id)}
              className={this.props.classes.nameInput}
              value={this.state.name}
              onChange={this.handleNameChange}
            />
          </Tooltip>
        )}
        onDelete={() => this.props.onArchiveTagClick(this.props.tag)}
        deleteIcon={
          this.props.tag.archived
            ? <Icon color="action" className={this.props.classes.smallIcon}>restore_from_trash</Icon>
            : <Icon color="action" className={this.props.classes.smallIcon}>delete</Icon>
        }
        onClick={this.handleEditNameClick}
      />
    );
  }
}

TagEditorComponent.propTypes = {
  classes: PropTypes.object,
  tag: PropTypes.object,
  tagTypes: PropTypes.array,
  onEditTag: PropTypes.func,
  onArchiveTagClick: PropTypes.func,
};

TagEditorComponent.defaultProps = {
  classes: {},
  tag: {},
  tagTypes: [],
  onEditTag: () => {},
  onArchiveTagClick: () => {},
};

export default withStyles(styles)((TagEditorComponent));
